// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"010fec85","239":"497224cf","453":"413c1390","455":"a4720dc7","465":"8e789482","755":"6588b645","757":"0974d627","977":"dd17d453"}[chunkId] + ".chunk.js";
};